import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=4b0f0704&scoped=true&"
import script from "./UserDetail.vue?vue&type=script&lang=ts&"
export * from "./UserDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0f0704",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b0f0704')) {
      api.createRecord('4b0f0704', component.options)
    } else {
      api.reload('4b0f0704', component.options)
    }
    module.hot.accept("./UserDetail.vue?vue&type=template&id=4b0f0704&scoped=true&", function () {
      api.rerender('4b0f0704', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/users/UserDetail.vue"
export default component.exports